"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INPUT_TYPES = void 0;
exports.default = _default;

var _assign = _interopRequireDefault(require("lodash/assign"));

var _keymirror = _interopRequireDefault(require("keymirror"));

var _tracking = require("@nerdwallet/nw-client-lib/tracking");

/* eslint max-len: 0 */
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

/**
 * Enum for some of input types supported on an HTML input.
 *
 * @readonly
 * @enum {String}
 */
var INPUT_TYPES = (0, _keymirror.default)({
  BUTTON: null,
  CHECKBOX: null,
  COLOR: null,
  DATE: null,
  DATETIME: null,
  DATETIME_LOCAL: null,
  EMAIL: null,
  FILE: null,
  HIDDEN: null,
  IMAGE: null,
  MONTH: null,
  NUMBER: null,
  PASSWORD: null,
  RADIO: null,
  RANGE: null,
  RESET: null,
  SEARCH: null,
  SUBMIT: null,
  TEL: null,
  TEXT: null,
  TIME: null,
  URL: null,
  WEEK: null
}); // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

exports.INPUT_TYPES = INPUT_TYPES;

function _default(trackingConfig) {
  return {
    INPUT_TYPES: INPUT_TYPES,

    /**
     * Integrates with the NWA library to dispatch the form input changed.
     *
     * @param fieldInfo The tracking info associated with the field
     *
     * @param fieldInfo.inputType [Optional] The type of input, as specified by the HTML input element. Defaults to 'text'
     * @param fieldInfo.fieldName Human-readable(-ish) name of a field, i.e. yearly-income. Should be drawn from the input's label element.
     *
     */
    trackInputChange: function trackInputChange(fieldInfo) {
      // Trigger the form input changed event.
      (0, _tracking.formInputChanged)((0, _assign.default)({
        inputType: INPUT_TYPES.TEXT
      }, trackingConfig, fieldInfo));
    }
  };
}